<template>
    <app-wrapper>
        <app-header
            :loan="loan"
            :page="'Make a payment'"
            :floating="'Confirm your payment details'"
            medium-max-width="max-w-1000"
            medium-max-width-inner="max-w-500">

            <template #navigation />

            <template #top-left>
                <div>Payment</div>
                <div>Account</div>
                <div>Account type</div>
            </template>

            <template #top-right>
                <div>$100.00</div>
                <div>Chase</div>
                <div>Checking (**** 1847)</div>
            </template>

            <template #top-bottom>
                <p class="font-normal">Payment will be scheduled for Mar 7, 2021</p>

                <a :href="`/account/loans/${loan.id}/make-payment`" class="block mt-4 w-full no-underline bg-white border border-primary-700 rounded text-primary-700 text-center text-lg font-semibold py-3">
                    Make Payment
                </a>

                <a :href="`/account/loans/${loan.id}/make-payment`" class="block mt-2 w-full no-underline bg-white border border-gray-200 rounded text-gray-700 text-center text-lg font-semibold py-3">
                    Cancel Payment
                </a>
            </template>

        </app-header>
        <app-body medium-max-width="max-w-500" footer short>

            <template #main>
                <ul class="list-disc list-outside pl-4">
                    <li>
                        <p class="leading-normal">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.
                        </p>
                    </li>
                    <li class="mt-3">
                        <p class="leading-normal">
                            Cras pellentesque, tortor dapibus sollicitudin dignissim, lectus nulla posuere metus, nec ornare erat dui sed purus.
                        </p>
                    </li>
                </ul>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
    export default {
        props: ['loan']
    }
</script>